import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";
export default {
  DoCreateActivityLog(activityLog) {
    let activityLogList = [];
    activityLogList.push({
      activityLogActionType: activityLog.activityLogActionType,
      referenceId: activityLog.referenceId,
      referenceId2: activityLog.referenceId2,
      note1: activityLog.note1,
      note2: activityLog.note2,
    });
    let _input = activityLogList;
    return API.peakLogAPI
      .post("/api/ActivityLog/InsertActivityLog", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetTransactionActivityLog(transactionId, transactionType, financeType) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transactionType: transactionType,
      financeType: financeType,
    };

    return API.peakLogAPI
      .get("/api/ActivityLog/GetTransactionActivityLog", { params, headers })
      .then((res) => {
        return res;
      })
      
  },
  DoGetRecurringTransactionActivityLog(transactionId, transactionType, financeType) {
    const headers = userInfo.SetHeaderService().headers;
    const params = {
      merchantId: userInfo.MerchantId(),
      transactionId: transactionId,
      transactionType: transactionType,
      financeType: financeType,
    };

    return API.peakLogAPI
      .get("/api/ActivityLog/GetRecurringTransactionActivityLog", { params, headers })
      .then((res) => {
        return res;
      })
      
  },
};
